import PaymentAbstractDialog from "./PaymentAbstractDialog";

export default class BillPaymentDialog extends PaymentAbstractDialog {

    title = "invoice.billPayment";
    dialogSaveLabel = "invoice.confirmPayment";

    get balanceLabel() {
        return "invoice.paymentSource";
    }

    showAllSum() {
        return true;
    }

    getSum() {
        const { totalSum, paidSum, } = this.info;
        return Math.round((totalSum || 0) - (paidSum || 0));
    }

    getItemMaxSum(bSum, sum) {
        return Math.min(bSum, sum);
    }

    showZeroItem() {
        return false;
    }

    joinSaveInfo(info) {
        const invoiceId = this.info.id || null;
        const clientId = this.info.clientId || null;

        return {
            ...info,
            direction: "DIRECTION_SUBSTRACT",
            hasCheck: true,
            clientId,
            invoiceId,
            invoiceNumber: {
                clientId,
                invoiceId,
            },
        };
    }

    renderMainBlock(info, sum) {
        const { invoiceNumber, createdTime } = info;
        const { clientId, invoiceId } = invoiceNumber || {};
        const date = this._helper.date.toDateStr(createdTime);
        const t = (this.tr("main.from2")).toLowerCase();
        const text = `${invoiceId || ""}/${clientId || ""} ${t} ${date}`;

        return (
            <div className="flex col gap8">
                <div className="text p1">{this.tr("invoice.payBillTitle")}</div>
                <div className="mainBlock flex gap8 pad8 rad4">
                    <div className="text p1SemiBold title">{text}</div>
                    <div className="text p1 colSec">{this._helper.number.toSum(sum)}</div>
                </div>
            </div>
        );
    }
}
